<!-- eslint-disable max-len -->
<template>
  <div class="view-contents">
    <div class="row title-row">
      <div class="col section-title section-header">Dashboard</div>
    </div>
    <b-row class='mb-3'>
      <b-col class='pl-3 pr-1'>
        <div v-if='myActiveProjectsLoading' class='card shadow rounded text-center dashboard-detail-card-loading-spinner'>
          <LoadingSpinner size = '2x'/>
        </div>
        <div v-else class='card shadow p-1 rounded text-center dashboard-detail-card-root'
          v-bind:class="{
            'dashboard-detail-card-text-active': isSelectedPanel('myActiveProjectsPanel')
          }"
          @click="onDashboardPanelClick('myActiveProjectsPanel')"
        >
          <div class='dashboard-detail-card-text-small'
            v-bind:class="{
              'dashboard-detail-card-text-active': isSelectedPanel('myActiveProjectsPanel')
            }"
          >My Active Projects</div>
          <div class='dashboard-detail-card-text-large'
            v-bind:class="{
              'dashboard-detail-card-text-active': isSelectedPanel('myActiveProjectsPanel')
            }"
          >{{myActiveProjectsTotal}}</div>
        </div>
      </b-col>
      <b-col v-if='isSiteAssessmentsPendingApprovalViewer' class='px-1'>
        <div v-if='siteAssessmentsPendingApprovalLoading' class='card shadow rounded text-center dashboard-detail-card-loading-spinner'>
          <LoadingSpinner size = '2x'/>
        </div>
        <div v-else class='card card-body shadow p-1 rounded text-center dashboard-detail-card-root'
          v-bind:class="{
            'dashboard-detail-card-text-active': isSelectedPanel('siteAssessmentsPendingApprovalPanel')
          }"
          @click="onDashboardPanelClick('siteAssessmentsPendingApprovalPanel')"
        >
          <div class='dashboard-detail-card-text-small'
            v-bind:class="{
              'dashboard-detail-card-text-active': isSelectedPanel('siteAssessmentsPendingApprovalPanel')
            }"
          >Site Assessments Pending Approval</div>
          <div class='dashboard-detail-card-text-large'
            v-bind:class="{
              'dashboard-detail-card-text-active': isSelectedPanel('siteAssessmentsPendingApprovalPanel')
            }"
          >{{siteAssessmentsPendingApprovalTotal}}</div>
        </div>
      </b-col>
      <b-col v-if='isProjectsPendingApprovalViewer' class='px-1'>
        <div v-if='projectsPendingApprovalLoading' class='card shadow rounded text-center dashboard-detail-card-loading-spinner'>
          <LoadingSpinner size = '2x'/>
        </div>
        <div v-else class='card shadow p-1 rounded text-center dashboard-detail-card-root'
          v-bind:class="{
            'dashboard-detail-card-text-active': isSelectedPanel('projectsPendingApprovalPanel')
          }"
          @click="onDashboardPanelClick('projectsPendingApprovalPanel')"
        >
          <div class='dashboard-detail-card-text-small'
            v-bind:class="{
              'dashboard-detail-card-text-active': isSelectedPanel('projectsPendingApprovalPanel')
            }"
          >Projects Pending Approval</div>
          <div class='dashboard-detail-card-text-large'
            v-bind:class="{
              'dashboard-detail-card-text-active': isSelectedPanel('projectsPendingApprovalPanel')
            }"
          >
            {{projectsPendingApprovalTotal}}
          </div>
        </div>
      </b-col>
      <b-col v-if='isWorkorderBillsPendingApprovalViewer' class='px-1'>
        <div v-if='workorderBillsPendingApprovalLoading' class='card shadow rounded text-center dashboard-detail-card-loading-spinner'>
          <LoadingSpinner size = '2x'/>
        </div>
        <div v-else class='card shadow p-1 rounded text-center dashboard-detail-card-root'
          v-bind:class="{
            'dashboard-detail-card-text-active': isSelectedPanel('workorderBillsPendingApprovalPanel')
          }"
          @click="onDashboardPanelClick('workorderBillsPendingApprovalPanel')"
        >
          <div class='dashboard-detail-card-text-small'
            v-bind:class="{
              'dashboard-detail-card-text-active': isSelectedPanel('workorderBillsPendingApprovalPanel')
            }"
          >Bills Pending Action</div>
          <div class='dashboard-detail-card-text-large'
            v-bind:class="{
              'dashboard-detail-card-text-active': isSelectedPanel('workorderBillsPendingApprovalPanel')
            }"
          >{{workorderBillsPendingApprovalTotal}}</div>
        </div>
      </b-col>
      <b-col v-if='isPendingBudgetViewer' class='px-1'>
        <div v-if='pendingBudgetsAreLoading' class='card shadow rounded text-center dashboard-detail-card-loading-spinner'>
          <LoadingSpinner size = '2x'/>
        </div>
        <div v-else class='card shadow p-1 rounded text-center dashboard-detail-card-root' v-bind:class="{'dashboard-detail-card-text-active': isSelectedPanel('budgetsPendingApprovalPanel')}" @click="onDashboardPanelClick('budgetsPendingApprovalPanel')">
          <div class='dashboard-detail-card-text-small' v-bind:class="{'dashboard-detail-card-text-active': isSelectedPanel('budgetsPendingApprovalPanel')}">
            <span>Budgets Pending Approval</span>
          </div>
          <div class='dashboard-detail-card-text-large' v-bind:class="{'dashboard-detail-card-text-active': isSelectedPanel('budgetsPendingApprovalPanel')}">
            {{budgetsPendingApprovalTotal}}
          </div>
        </div>
      </b-col>
    </b-row>
    <b-table
      v-if="isSelectedPanel('myActiveProjectsPanel')"
      :fields="myActiveProjectsFields"
      :items="myActiveProjects"
      :sort-by.sync="myActiveProjectsSortBy"
      :sort-desc.sync="myActiveProjectsSortDesc"
      bordered
      hover
      responsive
      small
      striped
    >
      <template v-slot:cell(projectName)="row">
        <router-link :to="{ name: 'ProjectOverview', params: { id: row.item.id }}">{{row.item.projectName}}</router-link>
      </template>
      <template v-slot:head(annualBudget)>
        {{fiscalYear}} Annual Budget
      </template>
      <template v-slot:cell(annualBudget)="row">
        {{ row.item.annualBudget | toCurrency }}
      </template>
      <template v-slot:head(fundsSpent)>
        {{fiscalYear}} Funds Spent
      </template>
      <template v-slot:cell(fundsSpent)="row">
        {{ row.item.fundsSpent | toCurrency }}
      </template>
      <template v-slot:head(fundsRemaining)>
        {{fiscalYear}} Funds Remaining
      </template>
      <template v-slot:cell(fundsRemaining)="row">
        {{ row.item.fundsRemaining | toCurrency }}
      </template>
    </b-table>
    <b-table
      v-if="isSelectedPanel('siteAssessmentsPendingApprovalPanel')"
      :fields="siteAssessmentsPendingApprovalFields"
      :items="siteAssessmentsPendingApproval"
      :sort-by.sync="siteAssessmentsPendingApprovalSortBy"
      :sort-desc.sync="siteAssessmentsPendingApprovalSortDesc"
      bordered
      hover
      responsive
      small
      striped
    >
      <template v-slot:cell(siteName)="row">
        <router-link :to="{ name: 'SiteAssessment', params: { id: row.item.siteId }}">{{row.item.siteName}}</router-link>
      </template>
    </b-table>
    <b-table
      v-if="isSelectedPanel('projectsPendingApprovalPanel')"
      :fields="projectsPendingApprovalFields"
      :items="projectsPendingApproval"
      :sort-by.sync="projectsPendingApprovalSortBy"
      :sort-desc.sync="projectsPendingApprovalSortDesc"
      bordered
      hover
      responsive
      small
      striped
    >
      <template v-slot:cell(projectName)="row">
        <router-link :to="{ name: 'ProjectOverview', params: { id: row.item.id }}">{{row.item.projectName}}</router-link>
      </template>
    </b-table>
    <b-table
      v-if="isSelectedPanel('workorderBillsPendingApprovalPanel')"
      :fields="workorderBillsPendingApprovalFields"
      :items="workorderBillsPendingApproval"
      :sort-by.sync="workorderBillsPendingApprovalSortBy"
      :sort-desc.sync="workorderBillsPendingApprovalSortDesc"
      bordered
      hover
      responsive
      small
      striped
    >
      <template v-slot:cell(billIdentifier)="row">
        <router-link :to="{ path: `project/${row.item.projectId}/workorders/${row.item.workOrderId}/bill/${row.item.id}`, params: { workOrderId: row.item.workOrderId, billId: row.item.id } }">
          {{row.item.billIdentifier}}
        </router-link>
      </template>
      <template v-slot:cell(projectName)="row">
        <router-link :to="{ name: 'ProjectOverview', params: { id: row.item.projectId }}">{{row.item.projectName}}</router-link>
      </template>
      <template v-slot:cell(workOrderId)="row">
        <router-link :to="{ path: `project/${row.item.projectId}/workorders/${row.item.workOrderId}`, params: { workOrderId: row.item.workOrderId } }">
          {{row.item.workOrderNumber}}
        </router-link>
      </template>
    </b-table>
    <b-table
      v-if="isSelectedPanel('budgetsPendingApprovalPanel')"
      :fields="pendingBudgetFields"
      :items="pendingBudgets"
      :sort-by.sync="pendingBudgetsSortBy"
      :sort-desc.sync="pendingBudgetsSortDesc"
      bordered
      hover
      responsive
      small
      striped
    >
      <template v-slot:cell(projectName)="row">
        <router-link :to="{ name: 'ProjectBudget', params: { id: row.item.projectId }}">{{row.item.projectName}}</router-link>
      </template>
      <template v-slot:cell(annualBudgetTotal)="row">
        {{ row.item.annualBudgetTotal | toCurrency }}
      </template>
    </b-table>
  </div>
</template>
<script>
/* eslint-disable max-len, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';
import DashboardHelper from '@/mixins/dashboardHelper';
import DashboardMembershipManager from '@/mixins/dashboardMembershipManager';
import FiscalYear from '@/mixins/fiscalYear';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import ProjectTotalsCalculator from '@/mixins/projectTotalsCalculator';

export default {
  name: 'Dashboard',
  components: {
    LoadingSpinner,
  },
  mixins: [
    DashboardHelper,
    DashboardMembershipManager,
    FiscalYear,
    ProjectTotalsCalculator,
  ],
  computed: {
    ...mapState(['config']),
    ...mapState('Membership', {
      memberOf: (state) => state.memberOf,
    }),
    ...mapState('Project', {
      myActiveProjects: (state) => state.myActiveProjects,
      pendingBudgets: (state) => state.pendingBudgets,
      projectsPendingApproval: (state) => state.projectsPendingApproval,
    }),
    ...mapState('SiteAssessment', {
      siteAssessmentsPendingApproval: (state) => state.siteAssessmentsPendingApproval,
      tualatinContacts: (state) => state.tualatinContacts,
    }),
    ...mapState('WorkorderBill', {
      workorderBillsPendingApproval: (state) => state.workorderBillsPendingApproval,
    }),
    budgetsPendingApprovalTotal() {
      return this.pendingBudgets.length;
    },
  },
  data() {
    return {
      fiscalYear: null,
      fiscalYearStart: null,
      fiscalYearEnd: null,
    };
  },
  mounted() {
    this.fiscalYear = this.getFiscalYear(new Date());
    this.fiscalYearStart = new Date(`${this.fiscalYear - 1}`, 6, 1);
    this.fiscalYearEnd = new Date(`${this.fiscalYear}`, 5, 30);
    this.$store.dispatch('Membership/fetchMemberOf').then(async () => {
      await this.loadMyActiveProjects();
      if (this.isSiteAssessmentsPendingApprovalViewer) {
        await this.loadSiteAssessmentsPendingApproval();
      }
      if (this.isProjectsPendingApprovalViewer) await this.loadProjectsPendingApproval();
      if (this.isWorkorderBillsPendingApprovalViewer) await this.loadWorkorderBillsPendingApproval();
      await this.loadPendingBudgets();
    });
  },
};
</script>
